import { Action } from 'redux';

import { TThunkAction } from '../../types/redux';
import { EMetaStatus } from '../../types/filters';
import { FILTERS_GET_META_TYPE } from '../../constants/action_types';
import { prepareMetaParameters } from '../../utils/prepareMetaParameters';
import { DEFAULT_CIAN_DOMAIN } from '../../constants/config';
import { fetchSearchMeta } from '../../services/fetchSearchMeta';

export type TGetMetaType = 'filters/get_meta/status_changed';

export interface IGetMetaFailed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Failed;
  error: string;
}

export interface IGetMetaSucceed extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Succeed;
  url: string;
  mapUrl: string;
  count: number;
}

export interface IGetMeta extends Action<TGetMetaType> {
  type: TGetMetaType;
  status: EMetaStatus.Loading;
}

export type TGetMeta = IGetMeta | IGetMetaFailed | IGetMetaSucceed;

let lastRequestId: Symbol;
export function getMeta(keepEvery?: boolean): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const requestId = (lastRequestId = Symbol());

    dispatch<TGetMeta>({
      type: FILTERS_GET_META_TYPE,
      status: EMetaStatus.Loading,
    });

    const {
      filters: { jsonQuery },
    } = getState();

    try {
      const meta = await fetchSearchMeta(context, { jsonQuery: prepareMetaParameters(jsonQuery) });

      if (!keepEvery && requestId !== lastRequestId) {
        return;
      }

      const { seoPath, queryString, subdomain, count } = meta;

      const domain = context.config.get<string>('mobile-filters-frontend.domain') || DEFAULT_CIAN_DOMAIN;

      const host = `https://${subdomain}.${domain}`;

      dispatch<TGetMeta>({
        type: FILTERS_GET_META_TYPE,
        status: EMetaStatus.Succeed,
        url: `${host}/${seoPath ? `${seoPath}/` : `cat.php?${queryString}`}`,
        mapUrl: `${host}/map/?${queryString}`,
        count,
      });
    } catch (e) {
      context.logger.warning(e);

      if (!keepEvery && requestId !== lastRequestId) {
        return;
      }

      dispatch<TGetMeta>({
        type: FILTERS_GET_META_TYPE,
        status: EMetaStatus.Failed,
        error: 'Произошла непредвиденная ошибка',
      });
    }
  };
}
